import React from 'react'

import { Button, Icon } from '@centivo/react-components'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { Nav, Navlist, Logo } from './components'
import { useNavbarFunctions } from './useNavbarFunctions'

interface NavbarProps {
  onRequestContact(): void
}

const StyledIcon = styled(Icon)`
  position: absolute;
  right: 1.25rem;
  top: 2rem;
`

export const NavbarDefault: React.FC<NavbarProps> = ({ onRequestContact }) => {
  const {
    onClickLink,
    clickToggle,

    style,
    isMobileView,
    contactLink,
    phoneNumber,
    phoneText,
    atLeastOneNavItem,
    shouldShowUnderConstruction,
    shouldShowContactForm,
    shouldShowNumberOnMenu,
    shouldShowAlreadyMember,
  } = useNavbarFunctions()

  return (
    <Nav className="main-navbar">
      <Link to="/">
        <Logo />
      </Link>
      {isMobileView && atLeastOneNavItem && !shouldShowUnderConstruction && (
        <Icon
          size="2rem"
          icon="menu"
          onClick={clickToggle}
          aria-label="Open menu"
        />
      )}
      <Navlist style={style} className="main-navlist" role="none">
        {isMobileView && (
          <li>
            <Link to="/" onClick={onClickLink}>
              <p>
                {isMobileView && <Icon icon="home" />}
                <span>Home</span>
              </p>
            </Link>
          </li>
        )}

        {shouldShowContactForm && !shouldShowUnderConstruction && (
          <li>
            {isMobileView ? (
              <Link to={contactLink} onClick={onClickLink}>
                <p>
                  {isMobileView && <Icon icon="mail" />}
                  <span>Contact us</span>
                </p>
              </Link>
            ) : (
              <Button buttonType="link" onClick={onRequestContact}>
                Contact us
              </Button>
            )}
          </li>
        )}
        {shouldShowNumberOnMenu && !shouldShowUnderConstruction && (
          <li>
            <a href={`tel:${phoneNumber}`}>
              <p>
                <Icon icon="phone" />
                <span>{phoneText}</span>
              </p>
            </a>
          </li>
        )}
        {shouldShowAlreadyMember && !shouldShowUnderConstruction && (
          <li>
            <a href="https://my.centivo.com/" onClick={onClickLink}>
              <p>
                {isMobileView && <Icon icon="users" />}
                <span>Already a member?</span>
              </p>
            </a>
          </li>
        )}
        {isMobileView && (
          <StyledIcon icon="x" size="2rem" onClick={clickToggle} />
        )}
      </Navlist>
    </Nav>
  )
}
